import React from 'react';
import Svg from '../icons/svg';

const LoadingInCenter = (props) => {
  const { show, label, fill, width, height, blur } = props;
  const className = blur ? 'align-items-center loading-bg-blur' : 'align-items-stretch place-center';

  if (show) {
    return (
      <div
        style={{
          width: width ? width + 'px' : '22px',
          height: height ? height + 'px' : '22px',
          zIndex: show ? 1 : 'inherit',
        }}
        className={`align-content-stretch justify-content-center align-items-center f-00auto bs-border-box ${className}`}
      >
        <Svg
          name={'loading'}
          label={label ? label : ''}
          width={width ? width : 22}
          height={height ? height : 22}
          fill={fill ? fill : '#2D2D30'}
        />
      </div>
    );
  } else {
    return <></>;
  }
};

export default LoadingInCenter;
